import { Component, OnInit } from '@angular/core';
import { RootDataMapping, ValueDataMapping, PropertyType } from '@ct-software/ct-ui-core';

import variableDictionary from './dashboard-variables.json';
import { AppConfigService } from '../app-config.service';
import { BackendApiService } from '../backendApi.service';

@Component({
    selector: 'dashboard-variables',
    templateUrl: './dashboard-variables.component.html',
    standalone: false
})
export class DashboardVariablesComponent implements OnInit {
  public variableMapping: RootDataMapping;
  public categoryMapping: RootDataMapping;

  private visibleVariables: any[];
  private categories: any[];
  private variables: any[];
  private newSampleValues: number = 0;

  constructor(private backendApiService: BackendApiService, private config: AppConfigService) { }

  public ngOnInit(): void {
    this.variables = variableDictionary;
    this.visibleVariables = this.variables;

    const hiddenCategories = ['Well Info', 'Job'];

    this.categories = this.variables.reduce((result, currentVariable) => {
      let existingCategory = result.filter(x => x.name === currentVariable.category);
      if (existingCategory.length > 0) {
        existingCategory[0].count++;
      } else {
        result.push({
          name: currentVariable.category,
          count: 1,
          hidden: hiddenCategories.includes(currentVariable.category)
        });
      }

      return result;
    }, [{ name: '(all)', count: this.variables.length }]);

    this.categories.sort((a, b) => a.name < b.name ? -1 : 1);

    const categoryMapping = new RootDataMapping(this.categories);
    new ValueDataMapping(categoryMapping, "Category", ["[]", "name"], { type: PropertyType.Text, width: 200 });
    new ValueDataMapping(categoryMapping, "Variable Count", ["[]", "count"], { type: PropertyType.Text, width: 50 });
    new ValueDataMapping(categoryMapping, "Hidden", ["[]", "hidden"], { type: PropertyType.Text, width: 50 });
    categoryMapping.readonly$.next(true);
    this.categoryMapping = categoryMapping;

    const variableMapping = new RootDataMapping(this.visibleVariables);
    new ValueDataMapping(variableMapping, "ID", ["[]", "name"], { type: PropertyType.Text, width: 180 });
    new ValueDataMapping(variableMapping, "Category", ["[]", "category"], { type: PropertyType.Text, width: 200 });
    new ValueDataMapping(variableMapping, "Display Name", ["[]", "displayName"], { type: PropertyType.Text, width: 200 });
    new ValueDataMapping(variableMapping, "Source", ["[]", "source"], { type: PropertyType.Text, width: 440});
    new ValueDataMapping(variableMapping, "Description", ["[]", "description"], { type: PropertyType.Text, width: 500 });
    new ValueDataMapping(variableMapping, "CoilCAT Name", ["[]", "coilCatDisplayName"], { type: PropertyType.Text, width: 470 });
    new ValueDataMapping(variableMapping, "Sample Value", ["[]", "sampleValue"], { type: PropertyType.Text, width: 200 });
    variableMapping.readonly$.next(true);
    this.variableMapping = variableMapping;

    for (let i = 0; i < this.variables.length; i++) {
      setTimeout(() => this.getSampleValue(this.variables[i]), 10 * i);
    }

    this.updateLoop();
  }

  public filterByCategory(indices) {
    this.visibleVariables = indices.length === 0 || indices.includes(0) ? this.variables : this.variables.filter(x => indices.map(i => this.categories[i].name).includes(x.category));
    this.updateGrid();
  }

  private getSampleValue(variable: any) {
    this.backendApiService.getText('/api/GetSampleValue?variableName=' + variable.name)
      .subscribe(value => {
        variable.sampleValue = value;
        this.newSampleValues++;
      });
  }

  private updateGrid() {
    this.variableMapping.setObject(this.visibleVariables);
  }

  private updateLoop() {
    if (this.variableMapping && this.newSampleValues > 0) {
      this.updateGrid();
      this.newSampleValues = 0;
    }

    // TODO: we should stop this update cycle when all sample values are downloaded
    setTimeout(() => this.updateGrid(), 1000);
  }
}
